import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import type { CompetitionId } from '@ps/isp-web-services-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { RootState } from '@swf/core/store';
import { SportsLink } from '@swf/sports/components';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';

import { TXTWCL_N0_logo } from './CompetitionsLink.messages.json';
import styles from './CompetitionsLink.scss';

const CompetitionLink: React.FC<{ competitionId: CompetitionId; logoUrl?: string }> = ({
  competitionId: compId,
  logoUrl
}) => {
  const { formatMessage } = useRegulatoryIntl();
  const { widgetSelect } = useEventMarketTemplatesWidget();

  const { competitionId, competitionSlug, competitionName, eventTypeId } = useSelector(
    (state: RootState) => widgetSelect.competition(state, compId)
  );

  const { eventTypeSlug } = useSelector((state: RootState) =>
    widgetSelect.eventType(state, eventTypeId)
  );

  return (
    <SportsLink
      className={styles.link}
      alias="sportsCompetition"
      values={{
        competitionId,
        competitionSlug,
        eventTypeId,
        eventTypeSlug
      }}
    >
      {logoUrl ? (
        <img
          className={styles.logoImg}
          src={logoUrl}
          alt={formatMessage(TXTWCL_N0_logo, { competitionName })}
        />
      ) : null}
      {competitionName}
      <Icon icon={ChevronMediumDown} className={styles.linkIcon} size="x1" />
    </SportsLink>
  );
};

export default CompetitionLink;
